import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import * as XLSX from 'xlsx';
import {ConsultingService, LoaderService, ReportService} from '@app/shared/services';
import {ModalDismissReasons, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {environment} from '@env/environment';
import numberToWords from 'number-to-words';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {Nl2BrPipe} from '@app/shared/pipe';
import {UtilsInjectable} from '@app/shared';
import {PageHeaderComponent} from '@app/components/page-header/page-header.component';
import { ReportPdfComponent } from '@app/components/report-pdf/report-pdf.component';

const EXCEL_EXTENSION = '.xlsx';

@Component({
  selector: 'app-cost-sheet',
  templateUrl: './cost-sheet.component.html',
  styleUrls: ['./cost-sheet.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    Nl2BrPipe,
    PageHeaderComponent,
    NgOptimizedImage,
    ReportPdfComponent
  ]
})
export class CostSheetComponent implements OnInit {
  @ViewChild('table') table?: ElementRef;

  user_rights: any;
  user_data: any;

  stock_data: any;
  closeResult = "";
  medicine: any;
  sale_return_quantity: any;
  sale_quantity = 0;
  fromdate = new Date;
  todate = new Date;
  start: any;
  limit: any;
  margin_total: any;
  item_list: any;
  save_rate = 0;
  gross = 0;
  saled: any;
  price_total = 0;
  numberToWords: any;
  vat_list: any;
  total_vat = 0;
  total_flood = 0;
  public institution = JSON.parse(localStorage.getItem('institution') || "{}");
  public logo_path = JSON.parse(localStorage.getItem('logo_path') || "{}");

  constructor(private loaderService: LoaderService,
              private modalService: NgbModal,
              public consultingService: ConsultingService,
              public reportService: ReportService,
              public utils: UtilsInjectable,
  ) {

  }

  ngOnInit() {
    this.user_rights = JSON.parse(localStorage.getItem('user_rights') || "{}");
    this.user_data = JSON.parse(localStorage.getItem('user') || "{}");
    this.fromdate = new Date(this.fromdate.getFullYear(), this.fromdate.getMonth(), 1, 23, 59, 59);
    this.todate = new Date(this.todate.getFullYear(), this.todate.getMonth() + 1, 0, 23, 59, 59);
    this.listCostSheet();
  }

  public getToday(): string {
    return new Date().toISOString().split('T')[0]
  }

  public listCostSheet() {
    const postData = {
      invoice_date_from: this.fromdate,
      invoice_date_to: this.todate,
      start: this.start,
      limit: this.limit
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.consultingService.listCostSheet(postData).subscribe((result: any) => {
      this.loaderService.display(false);
      if (result['status'] == 'success') {
        this.stock_data = result['data'];
        this.BalVatamount();
        let total = 0;
        for (const data of this.stock_data) {
          total = total + parseFloat(data.MARGIN);
        }
        this.margin_total = total;
      } else {
        this.stock_data = []
        this.margin_total = 0
      }
    });
  }

  public BalVatamount() {
    let i = 0
    for (const data of this.stock_data) {
      const margin = (parseFloat(data.Costsheet['total_sell']) - parseFloat(data.Costsheet['total_purchase'])).toFixed(2);
      data["PURCHASE"] = data.Costsheet['total_purchase']
      data["SALE"] = data.Costsheet['total_sell']
      data["MARGIN"] = margin;
      this.stock_data[i] = data;
      i = i + 1;
    }
  }

  public round(num: any) {
    return Math.round(num)
  }

  getSum() {
    let total = 0;
    let save = 0;
    for (const item of this.item_list) {
      total = total + parseFloat(item.TOTAL);
      save = save + parseFloat(item.SAVE_RATE);
    }
    this.save_rate = Math.round(save);
    this.gross = total
    if (this.saled) {
      this.price_total = Math.round((this.gross - parseFloat(this.saled.DISCOUNT)) + parseFloat(this.saled.FREIGHT_CHARGE))
    } else {
      this.price_total = Math.round(this.gross)
    }
    this.numberToWords = (numberToWords.toWords(this.price_total));
  }

  public getVatValue() {
    const postData = {
      sale_id: this.saled.SALE_ID,
      state_code: this.saled.TIN_NUMBER
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.reportService.getVatValue(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.vat_list = result['data'];
        let total_vat = 0;
        let total_flood = 0;
        for (const vat of this.vat_list) {
          total_vat = total_vat + parseFloat(vat.VAT_VALUE)
          total_flood = total_flood + parseFloat(vat.FLOOD_CESS)
        }
 
        this.total_vat = (total_vat)
        this.total_flood = (total_flood)
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);
      }
    });
  }

  public sale_items(item: any) {
    const postData = {
      sale_id: item
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.reportService.getSale(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.saled = result['data'];
        this.item_list = result['data'].SALE;
        let i = 0;
        for (const data of this.item_list) {

          const unit = parseFloat(data.UNIT_PRICE);
          const vat = parseFloat(data.VAT);
          if (this.saled && this.saled.TIN_NUMBER == 32) {
            data["BASE_PRICE"] = ((unit / (environment.FLOOD_CESS_PERCENTAGE + 100)) * 100).toFixed(2)
          }
          if (this.saled && this.saled.TIN_NUMBER != 32) {
            data["BASE_PRICE"] = ((unit / (vat + environment.FLOOD_CESS_PERCENTAGE + 100)) * 100).toFixed(2)
          }
          this.item_list[i] = data;
          i = i + 1;
        }
        this.getVatValue();
        this.getSum();
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);
      }
    });
  }

  protected open(content: any) {
    this.modalService.open(content, {
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg',
      windowClass: "col-md-12"
    }).result.then((result: any) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason == ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason == ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  public ExportToExcel() {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.table?.nativeElement, {
      dateNF: 'dd/mm/yyyy;@',
      cellDates: true,
      raw: true
    });
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    /* save to file */
    XLSX.writeFile(wb, 'Purchase' + new Date().getTime() + EXCEL_EXTENSION);

  }
}
